// Copyright (c) 2020 Siemens
// NO_SONAR
import _ from 'lodash';
import AwButton from 'viewmodel/AwButtonViewModel';

export const awFileUploadLabelFunction = ( props ) => {
    const { name, size, webkitRelativePath, status } = props.item;
    let fileName = webkitRelativePath ? webkitRelativePath : name;
    let displayedSize = `(${ ( size / 1000000 ).toFixed( 3 )}${props.i18n.MB})`;
    let { removeTooltip } = props;
    removeTooltip = removeTooltip === undefined ? props.i18n.removeFileBtnTooltip : removeTooltip;
    return (
        <div className='sw-row aw-file-upload-details'>
            <div className = 'aw-file-upload-text'>{fileName}</div>
            <div className = 'propertyLabelTopContainer' >
                <div className = 'aw-file-upload-text'>{displayedSize}</div>
                <div className = 'aw-file-status-text'>{status}</div>
                <AwButton className='aw-file-dir-remove-button' iconId = 'cmdClearText' tooltip={removeTooltip} action = { ( e ) => props.removeFileHandler( e, name ) }> </AwButton>
            </div>
        </div>
    );
};
// NO_SONAR
